import { DeclareMethod } from '/imports/methods';

/** Documentation metadata for one registered REST route. Shared shape between
 *  the server route registry (api.ts RouteDoc) and the in-app docs page. */
export interface ApiRouteDoc {
  method: string;
  path: string;
  body?: any;
  doc?: {
    summary?: string;
    description?: string;
    params?: { [name: string]: string };
    query?: { [name: string]: string };
    response?: any;
    tags?: string[];
  };
}

export const getApiDocs = DeclareMethod<undefined, ApiRouteDoc[]>('getApiDocs');
